import { NgModule } from '@angular/core';
import { UserListComponent } from './pages/user-list/user-list.component';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { SharedModule } from '@shared/shared.module';
import { UserRoutingModule } from '.';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';

@NgModule({
    declarations: [UserListComponent, UserProfileComponent],
    imports: [CustomFormModule, UserRoutingModule, SharedModule]
})
export class UserModule {}
